<template>
  <div style="width: 100%;">
    <div>客资来源</div>
    <div style="width:100%;  display: flex;" class="six">
      <div id="sixcopy" style="width:100%; height:200px">
      </div>
    </div>

    <el-dialog  title="定金分析详情" append-to-body :close-on-click-modal="false" :visible.sync="isTable"   width="80%"  :before-close="handleisShowRepresentative">
        <el-table :data="list" border height="700"  :header-cell-style="{'text-align':'center', background: '#fafafa', }" :cell-style="{'text-align':'center'}">
          <el-table-column :resizable="false" prop="customerId" label="订单号"></el-table-column>
          <el-table-column :resizable="false" prop="customerWx" label="微信" align="center"></el-table-column>
          <el-table-column :resizable="false" prop="regionName" label="城市" align="center">
            <template v-slot="scope">
                <span v-if="scope.row.regionName === 1 || scope.row.regionName === '1'">北京</span>
                <span v-if="scope.row.regionName === 2 || scope.row.regionName === '2'">上海</span>
                <span v-if="scope.row.regionName === 3 || scope.row.regionName === '3'">深圳</span>
                <span v-if="scope.row.regionName === '北京'">北京</span>
                <span v-if="scope.row.regionName === '上海'">上海</span>
                <span v-if="scope.row.regionName === '深圳'">深圳</span>
            </template>
          </el-table-column>
          <el-table-column :resizable="false" prop="customerStudent" label="学生姓名"></el-table-column>
          <el-table-column :resizable="false" prop="grade" label="年级"></el-table-column>
          <el-table-column :resizable="false" prop="parentPhoneNumber" label="家长电话"></el-table-column>
          <el-table-column :resizable="false" prop="classType" label="学生类型">
            <template v-slot="scope">
                <span v-if="scope.row.classType === 1">规划</span>
                <span v-if="scope.row.classType === 2">线下</span>
                <span v-if="scope.row.classType === 3">纯补课</span>
            </template>
          </el-table-column>
          <el-table-column :resizable="false" prop="orderStatus" label="订单状态">
            <template v-slot="scope">
                <span v-if="scope.row.orderStatus === 0">待成单</span>
                <span v-if="scope.row.orderStatus === 1">已成单</span>
                <span v-if="scope.row.orderStatus === 2">未成单</span>
                <span v-if="scope.row.orderStatus === 3">已退费</span>
            </template>
          </el-table-column>
          <el-table-column :resizable="false" prop="state" label="学生状态">
            <template v-slot="scope">
              <span v-if="scope.row.state === 1">在读</span>
              <span v-if="scope.row.state === 2">结业</span>
              <span v-if="scope.row.state === 3">停课</span>
              <span v-if="scope.row.state === 4">流失</span>
            </template>
          </el-table-column>
          <el-table-column :resizable="false" prop="customerAccountName" label="销售">
            <template v-slot="scope">
              <span v-if="scope.row.customerAccountName === '10015'">杨佳琪</span>
              <span v-else-if="scope.row.customerAccountName === '10014'">王威</span>
              <span v-else-if="scope.row.customerAccountName === '15201251274'">苏芮</span>
              <span v-else>{{ scope.row.customerAccountName ? scope.row.customerAccountName : scope.row.customerAccount  }}</span>
            </template>
          </el-table-column>
          <el-table-column :resizable="false" prop="diagnoseTeacherName" label="诊断师"></el-table-column>
          <el-table-column :resizable="false" prop="trafficSource" label="投流状态">
            <template v-slot="scope">
              <span v-if="scope.row.trafficSource === 1">自然</span>
              <span v-if="scope.row.trafficSource === 2">付费流</span>
            </template>
          </el-table-column>
          <el-table-column :resizable="false" prop="customerTeacherid" label="IP老师">
            <template v-slot="scope">
              <span v-if="scope.row.customerTeacherid === 1">小单老师</span>
              <span v-if="scope.row.customerTeacherid === 2">大单老师</span>
              <span v-if="scope.row.customerTeacherid === 3">刘老师</span>
              <span v-if="scope.row.customerTeacherid === 4">杨老师</span>
              <span v-else></span>
            </template>
          </el-table-column>
          <el-table-column :resizable="false" prop="onlineStatus" label="线上预约">
            <template v-slot="scope">
              <span>{{ scope.row.onlineStatus == 1 ? "是" : "否" }}</span>
            </template>
          </el-table-column>
          <el-table-column :resizable="false" prop="offlineStatus" label="线下预约">
            <template v-slot="scope">
              <span>{{ scope.row.offlineStatus == 1 ? "是" : "否" }}</span>
            </template>
          </el-table-column>
          <el-table-column :resizable="false" prop="channelType" label="渠道">
            <template v-slot="scope">
              <span v-if="scope.row.channelType === 1">线上</span>
              <span v-if="scope.row.channelType === 2">线下</span>
            </template>
          </el-table-column>
          <el-table-column :resizable="false" prop="sourceName" label="来源"></el-table-column>
          <el-table-column :resizable="false" prop="sourcepeopleName" label="来源负责人"  width="120"></el-table-column>
          <el-table-column :resizable="false" prop="customerPaytime" label="定金时间"></el-table-column>
          <el-table-column :resizable="false" prop="orderDate" label="创建时间"></el-table-column>
        </el-table>
        <el-pagination 
          layout="prev, pager, next,sizes, jumper" 
          @size-change="handleSizeChange" 
          @current-change="handleCurrentChange" 
          :current-page="pageNum" 
          :page-size="pageSize"
          :total="total" 
          style="text-align: end;padding-top: 30px;">
        </el-pagination>
    </el-dialog>

  </div>
</template>

<script>
import * as echarts from 'echarts';
import axios from 'axios'
import apiBaseUrl from '../../../config/api'
export default {
  props: {
    list5: Array,
    times: Array,
  },
  name: "",
  data () {
    return {
      myChart: null,
      isTable: false,
      list:[],

      id: '',

      total: 0,
      pageNum: 1,
      pageSize: 10,
    }
  },
  mounted () {
    this.initBie()
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val
      this.handlesourceDetail()
    },

    handleCurrentChange(val) {
      this.pageNum = val
      this.handlesourceDetail()
    },

    handleisShowRepresentative(){
      this.isTable = false
      this.id = ''
      this.list = []
      this.pageNum = 1
      this.pageSize = 10
    },

    handlesourceDetail(){
        let data = {
          sourceId: this.id,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          time: this.times,
          type: 2,
        }
        axios.post(`${apiBaseUrl}/stat/sourceDetail`,data,{headers:{'authorization': sessionStorage.getItem('tokenInfo')}, }).then(res => {
          if (res.data.code == 200) {
            this.list = res.data.data && res.data.data.entity
            this.total = res.data.data && res.data.data.allTotal
          } else {
            this.list = []
            this.total = 0
            this.$message({ message: res.data.message || res.data.msg , type: "error"  });
          }
        }).catch(error => {
          this.list = []
          this.total = 0
          this.$message({ message: error,  type: "error"  });
        });
    },

    initBie () {
      let chartDom = document.getElementById('sixcopy');
      this.myChart = echarts.init(chartDom);
      let option;

      option = {
        color: ['#D9503F', '#68BAC5', '#F3BD43', '#58A55A', '#5087EB'],
        title: {
          text: '',
          // subtext: 'Fake Data',
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'left'
        },
        series: [
          {
            // name: 'Access From',
            type: 'pie',
            radius: '50%',
            data:this.list5,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };

      option && this.myChart.setOption(option);

      this.myChart.on('click', (params) => {
        let { id } = params.data;
        if(id){
          this.id = id
          this.isTable = true
          this.handlesourceDetail();
        }
      });
      // window.onresize = function () {
      //   myChart.resize();
      // }
    }
  },
  watch: {
    list5: {
      deep: true,
      handler (val) {
        this.initBie()
      },
    },
  },
  components: {

  },
}
</script>

<style scoped></style>




// WEBPACK FOOTER //
// src/statistics/components/income5copy.vue